const canonicalURl = 'https://memorialday2026.ynet.co.il/';

// Seo title and description
export const seoTitle = 'החלל שלי 2026 – ynet';
export const seoDescription =
	'ביום הזיכרון עומדת ישראל מלכת - כדי לתת מקום למי שאיננו. פרויקט ההנצחה השנתי של ynet, מזמין גם השנה את כולם, לספר את סיפורם של הנופלים, לראות את תמונתם, לזכור ולהזכיר את אלו שהיו ואינם עוד';

// Share variables
export const shareUrl = 'https://memorialday2026.ynet.co.il/';
export const shareTitle = 'החלל שלי 2026 – ynet';
export const shareDescription =
	'יום הזיכרון לחללי מערכות ישראל 2026 תשפ״ו. הפרויקט השנתי של ynet - הדליקו נר לזכר הנופלים, שתפו ברגעים ובתמונות';

//! Attention: do not import og images as variable, write path here:
export const shareImage = `${canonicalURl}/assets/client/share.jpg`;
